import { getPrice } from '../utils/prices'

/** Prices shown on the homepage, read from the same data as the Prices page. */
export const newPatientExamPrice = getPrice(
  'consultations',
  'New Patient Exam (incl. 2 X-Rays)',
)
export const scaleAndPolishPrice = getPrice('hygiene', 'Scale & Polish')
export const orthodonticConsultationPrice = getPrice(
  'consultations',
  'Orthodontics Consultation',
)
